import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "contact_id": {
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": null
      },
      "name": "contact_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "expires_at": {
      "column": {
        "default": null,
        "name": "expires_at",
        "null": true,
        "type": "datetime"
      },
      "name": "expires_at",
      "selected_by_default": null,
      "translated": null
    },
    "given_at": {
      "column": {
        "default": null,
        "name": "given_at",
        "null": false,
        "type": "datetime"
      },
      "name": "given_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "notification_type_action_id": {
      "column": {
        "default": null,
        "name": "notification_type_action_id",
        "null": true,
        "type": null
      },
      "name": "notification_type_action_id",
      "selected_by_default": null,
      "translated": null
    },
    "notification_type_audit_trigger_id": {
      "column": {
        "default": null,
        "name": "notification_type_audit_trigger_id",
        "null": true,
        "type": null
      },
      "name": "notification_type_audit_trigger_id",
      "selected_by_default": null,
      "translated": null
    },
    "points": {
      "column": {
        "default": null,
        "name": "points",
        "null": false,
        "type": "integer"
      },
      "name": "points",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ContactPoint",
  "collectionKey": "contact_points",
  "collectionName": "contact_points",
  "i18nKey": "contact_point",
  "camelizedLower": "contactPoint",
  "name": "ContactPoint",
  "nameDasherized": "contact-point",
  "pluralName": "contact_points",
  "ransackable_associations": [
    {
      "className": "ContactPoint::Audit",
      "collectionName": "contact_point_audits",
      "foreignKey": "contact_point_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "ContactPointAudit",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "ContactPoint::Audit",
      "collectionName": "contact_point_audits",
      "foreignKey": "contact_point_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "ContactPointAudit",
      "through": null
    },
    {
      "className": "NotificationTypeAction",
      "collectionName": "notification_type_actions",
      "foreignKey": "notification_type_action_id",
      "name": "notification_type_action",
      "macro": "belongs_to",
      "resource_name": "NotificationTypeAction",
      "through": null
    },
    {
      "className": "NotificationTypeAuditTrigger",
      "collectionName": "notification_type_audit_triggers",
      "foreignKey": "notification_type_audit_trigger_id",
      "name": "notification_type_audit_trigger",
      "macro": "belongs_to",
      "resource_name": "NotificationTypeAuditTrigger",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "description",
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "expires_at",
      "column": {
        "default": null,
        "name": "expires_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "given_at",
      "column": {
        "default": null,
        "name": "given_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "notification_type_action_id",
      "column": {
        "default": null,
        "name": "notification_type_action_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "notification_type_audit_trigger_id",
      "column": {
        "default": null,
        "name": "notification_type_audit_trigger_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "points",
      "column": {
        "default": null,
        "name": "points",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "active",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "NotificationTypeAction",
      "collectionName": "notification_type_actions",
      "foreignKey": "notification_type_action_id",
      "name": "notification_type_action",
      "macro": "belongs_to",
      "resource_name": "NotificationTypeAction",
      "through": null
    },
    {
      "className": "NotificationTypeAuditTrigger",
      "collectionName": "notification_type_audit_triggers",
      "foreignKey": "notification_type_audit_trigger_id",
      "name": "notification_type_audit_trigger",
      "macro": "belongs_to",
      "resource_name": "NotificationTypeAuditTrigger",
      "through": null
    }
  ],
  "paramKey": "contact_point",
  "primaryKey": "id"
}

/** Frontend model for ContactPoint. */
class ContactPoint extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  contactId() {
    return this.readAttributeUnderscore("contact_id")
  }

  /** @returns {boolean} */
  hasContactId() {
    const value = this.contactId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  expiresAt() {
    return this.readAttributeUnderscore("expires_at")
  }

  /** @returns {boolean} */
  hasExpiresAt() {
    const value = this.expiresAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  givenAt() {
    return this.readAttributeUnderscore("given_at")
  }

  /** @returns {boolean} */
  hasGivenAt() {
    const value = this.givenAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  notificationTypeActionId() {
    return this.readAttributeUnderscore("notification_type_action_id")
  }

  /** @returns {boolean} */
  hasNotificationTypeActionId() {
    const value = this.notificationTypeActionId()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  notificationTypeAuditTriggerId() {
    return this.readAttributeUnderscore("notification_type_audit_trigger_id")
  }

  /** @returns {boolean} */
  hasNotificationTypeAuditTriggerId() {
    const value = this.notificationTypeAuditTriggerId()

    return this._isPresent(value)
  }

  /** @returns {number} */
  points() {
    return this.readAttributeUnderscore("points")
  }

  /** @returns {boolean} */
  hasPoints() {
    const value = this.points()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readBelongsToReflection({reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("contactId" in this)) throw new Error("Foreign key method wasn't defined: contactId")

    const id = this.contactId()
    const modelClass = modelClassRequire("Contact")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "contact", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("./notification-type-action.js").default | null} */
  notificationTypeAction() {
    return this._readBelongsToReflection({reflectionName: "notification_type_action"})
  }

  /** @returns {Promise<import("./notification-type-action.js").default | null>} */
  loadNotificationTypeAction() {
    if (!("notificationTypeActionId" in this)) throw new Error("Foreign key method wasn't defined: notificationTypeActionId")

    const id = this.notificationTypeActionId()
    const modelClass = modelClassRequire("NotificationTypeAction")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "notification_type_action", model: this, modelClass},
      {ransack}
    )
  }

  /** @returns {import("./notification-type-audit-trigger.js").default | null} */
  notificationTypeAuditTrigger() {
    return this._readBelongsToReflection({reflectionName: "notification_type_audit_trigger"})
  }

  /** @returns {Promise<import("./notification-type-audit-trigger.js").default | null>} */
  loadNotificationTypeAuditTrigger() {
    if (!("notificationTypeAuditTriggerId" in this)) throw new Error("Foreign key method wasn't defined: notificationTypeAuditTriggerId")

    const id = this.notificationTypeAuditTriggerId()
    const modelClass = modelClassRequire("NotificationTypeAuditTrigger")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "notification_type_audit_trigger", model: this, modelClass},
      {ransack}
    )
  }
}

export default ContactPoint
